import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import { StyledEngineProvider } from '@mui/material/styles';
import { ToastProvider } from '@thingslog/ui-components';
import { ReactQueryWrapper } from '@thingslog/queries';
import './libs/i18n/i18n';

// #region render
ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter basename="/portal">
      <StyledEngineProvider injectFirst>
        <ToastProvider>
          <ReactQueryWrapper>
            <App />
          </ReactQueryWrapper>
        </ToastProvider>
      </StyledEngineProvider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);
// #endregion
